"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _default = {
  spaceBetweenElements: 16,
  spaceBetweenTitleAndDescription: 6
};
exports["default"] = _default;